var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 12.7513V16.2513C15.3334 19.168 14.1667 20.3346 11.25 20.3346H7.75002C4.83335 20.3346 3.66669 19.168 3.66669 16.2513V12.7513C3.66669 9.83464 4.83335 8.66797 7.75002 8.66797H11.25C14.1667 8.66797 15.3334 9.83464 15.3334 12.7513Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3334 7.7513V11.2513C20.3334 14.168 19.1667 15.3346 16.25 15.3346H15.3334V12.7513C15.3334 9.83463 14.1667 8.66797 11.25 8.66797H8.66669V7.7513C8.66669 4.83464 9.83335 3.66797 12.75 3.66797H16.25C19.1667 3.66797 20.3334 4.83464 20.3334 7.7513Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyKey);
export default __webpack_public_path__ + "static/media/copy-key.b56eb3634129964198bec1abb3f7cfcc.svg";
export { ForwardRef as ReactComponent };